import { render, staticRenderFns } from "./newRecordedInfo.vue?vue&type=template&id=626e54ed&scoped=true"
import script from "./newRecordedInfo.vue?vue&type=script&lang=js"
export * from "./newRecordedInfo.vue?vue&type=script&lang=js"
import style0 from "./newRecordedInfo.vue?vue&type=style&index=0&id=626e54ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e54ed",
  null
  
)

export default component.exports